export const navbar = {
  'anonymous.logInOrSignUp': 'Login or join',
  'nav-bar.a11y.label': 'navigation bar for {routeName} page',
  // Menu
  'nav-bar.menu.title': 'Menu',
  'nav-bar.menu.title-named': 'Menu: {name}',
  // Sweetpass
  'nav-bar.sweetpass.title': 'sweetpass',
  // Challenges
  'nav-bar.challenges.title': 'Challenges',
  // Home / Sweetgreen Logo
  'nav-bar.home.title': 'Home',
  'nav-bar.home.accessibility-label': 'Home',
  // Account
  'nav-bar.account.title': 'Account',
  // Bag
  'nav-bar.bag.closed.accessibility-label': 'Open Bag',
  'nav-bar.bag.open.accessibility-label': 'Close Bag',
  // Dietary Restrictions
  'nav-bar.dietary-restrictions.accessibility-label': 'Dietary Restrictions',
  'nav-bar.dietary-restrictions.accessibility-hint':
    'Opens dietary preferences',
};
